import { examSessionTrackingSerializationModule } from '../serialization';

export const examSessionScorm2004TrackingModules = [
  examSessionTrackingSerializationModule
]
